import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const MaterialForm_Material_Fragment = graphql(`
  fragment MaterialForm_Material_Fragment on Material {
    _id
    codingConfig {
      kind
      strategyId
      ... on CodingConfigManual {
        code
      }
      ...CodeCmp_CodingConfig_Fragment
    }
    code
    label
    title
    content
    statusId
    costUsages {
      __typename
      _id
      costId
      quantity {
        value
        unitId
      }
      index
      ...CostUsageForm_CostUsage_Fragment
    }
  }
`);

export type MaterialForm_Material = ResultOf<
  typeof MaterialForm_Material_Fragment
>;
